/**
 * Tier submission limits - MUST match functions-forms/src/shared/tiers.ts
 *
 * Admin override: When tier is 'custom', use userProfile.submissionLimit if set.
 * business kept for backward compat (maps to professional).
 */
export const TIER_SUBMISSION_LIMITS = {
  free: 10,
  starter: 40,
  growth: 100,
  professional: 250,
  enterprise: 500,
  custom: 10000,
  business: 250, // deprecated -> professional
};

export const TIER_FORM_LIMITS = {
  free: 1,
  starter: 1,
  growth: -1,
  professional: -1,
  enterprise: -1,
  custom: -1,
  business: -1,
};

export const TIER_WORKSPACE_LIMITS = {
  free: 1,
  starter: 1,
  growth: 3,
  professional: 10,
  enterprise: -1,
  custom: -1,
  business: 10,
};

/**
 * Display overage USD per lead. Source of truth is
 * functions-forms/src/wallet/pricing.ts LEAD_OVERAGE_MICROS_BY_TIER.
 */
export const LEAD_OVERAGE_USD_BY_TIER = {
  starter: 2.5,
  growth: 2,
  professional: 1.5,
  enterprise: 1,
  custom: 1,
  business: 1.5,
};

/**
 * Get display limit for a tier. Use tier default so display matches plan (e.g. growth = 100).
 * Only use profile override when tier is 'custom' (testers, special pricing).
 */
export function getSubmissionLimitForTier(tier, profileSubmissionLimit) {
  const t = tier || 'free';
  if (t === 'custom' && typeof profileSubmissionLimit === 'number' && profileSubmissionLimit > 0) {
    return profileSubmissionLimit;
  }
  return TIER_SUBMISSION_LIMITS[t] ?? TIER_SUBMISSION_LIMITS.free;
}

export function getFormLimitForTier(tier) {
  const t = tier || 'free';
  return TIER_FORM_LIMITS[t] ?? TIER_FORM_LIMITS.free;
}

export function getWorkspaceLimitForTier(tier) {
  const t = tier || 'free';
  return TIER_WORKSPACE_LIMITS[t] ?? TIER_WORKSPACE_LIMITS.free;
}

export function resolveEffectiveTier(userProfile) {
  return userProfile?.tier || userProfile?.subscriptionPlan || 'free';
}
